<template>
    <div>
        <table class="table">
            <tr class="header">
                <th>Datum</th>
                <th>USt</th>
                <th>Brutto-Betrag</th>
                <th>Auslage</th>
                <th></th>
            </tr>
            <template v-for="invoicePayment in invoicePayments">
                <invoice-payment-form :initial-data="invoicePayment" v-if="editedItemId===invoicePayment.id" @updated="fetchInvoicePayments()" />
                <tr class="content" v-else>
                    <td>{{ invoicePayment.date | toDate }}</td>
                    <td>{{ invoicePayment.sales_tax_percent }}%</td>
                    <td class="text-right">{{ invoicePayment.amount | toCurrency }}</td>
                    <td>
                      <span v-if="invoicePayment.is_refund" class="text-sm font-medium bg-red-100 py-1 px-2 rounded text-red-500 align-middle ml-2">
                        Auslage
                      </span>
                    </td>
                    <td>
                        <button class="btn btn-small btn-secondary mr-4" @click="editedItemId=invoicePayment.id" :disabled="editedItemId !== null">
                            <i class="fas fa-edit"></i> bearbeiten
                        </button>
                        <button class="btn btn-small btn-remove" @click="destroy(invoicePayment.id)" :disabled="editedItemId !== null">
                            <i class="far fa-trash-alt"></i> löschen
                        </button>
                    </td>
                </tr>
            </template>
            <invoice-payment-form :invoice-id="invoiceId" v-if="editedItemId==='new'" @updated="fetchInvoicePayments()" />
            <tr class="content" v-else>
                <td colspan="4">
                    <button class="btn btn-small btn-secondary" @click="editedItemId='new'" :disabled="editedItemId !== null">
                        <i class="far fa-plus-square"></i> hinzufügen
                    </button>
                </td>
            </tr>
            <tr class="content border-t-2 border-gray-600">
                <td class="font-bold">Gesamt</td>
                <td></td>
                <td class="text-right font-bold">{{ sumPayments() | toCurrency }}</td>
                <td></td>
                <td></td>
            </tr>
        </table>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: ['invoiceId'],
        data: function() {
            return {
                invoicePayments: [],
                editedItemId: null,
            }
        },
        filters: {
            toDate: function(value, format = 'DD.MM.YYYY') {
                if (value == null) {
                    return value;
                }
                return moment(value).format(format);
            },
            toCurrency: function(value) {
                if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                });
                return formatter.format(value);
            }
        },
        methods: {
            fetchInvoicePayments: function() {
                this.$http['get']('/invoice_payments.json', {params: {
                        invoice_id: this.invoiceId,
                    }}).then(response => {
                    console.log(response.body)
                    this.invoicePayments = response.body['invoice_payments']
                    this.editedItemId = null
                    this.$forceUpdate()
                }, response => {
                    console.log(response)
                })
            },
            destroy: function(id) {
                this.$confirm(
                    {
                        message: `Wirklich löschen? 😱`,
                        button: {
                            no: 'Abbrechen',
                            yes: 'Löschen'
                        },
                        /**
                         * Callback Function
                         * @param {Boolean} confirm
                         */
                        callback: confirm => {
                            if (confirm) {
                                this.$http['delete']('/invoice_payments/' + id).then(response => {
                                    this.fetchInvoicePayments()
                                }, response => {
                                    // console.log(response)
                                    if (response.status = 422) {

                                    } else {
                                    }
                                })
                            }
                        }
                    }
                )
            },
            sumPayments: function() {
                return this.invoicePayments.map(ip => ip.amount).reduce((a, b) => a + b, 0)
            },
        },
        mounted: function() {
            this.fetchInvoicePayments()
        }
    }
</script>
